import { apiClient } from './apiClient';

export const cartService = {
  async getCartItemCount() {
    return apiClient.get('/cart/item-count');
  },

  async getCart() {
    return apiClient.get('/cart');
  },

  async increaseQty(couponId) {
    return apiClient.put(`/cart/increase/${couponId}`);
  },

  async decreaseQty(couponId) {
    return apiClient.put(`/cart/decrease/${couponId}`);
  },

  async removeItem(couponId) {
    return apiClient.delete(`/cart/remove/${couponId}`);
  },

  async addToCart(couponId) {
    return apiClient.post('/cart/add', { couponId });
  },

  async syncCart(cartItems) {
    return apiClient.post('/cart/sync', cartItems);
  },

  async clearCart() {
    return apiClient.delete('/cart/delete');
  },
};




